import React from "react";
import * as S from "./styles";
export var Committed = function Committed(e) {
  return React.createElement(S.SVG, Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    "aria-hidden": "true"
  }, e), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: "1.5"
  }, React.createElement("path", {
    strokeLinecap: "round",
    d: "M21.333 22.667L21.333 31.333 16 26 10.667 31.333 10.667 22.667"
  }), React.createElement("circle", {
    cx: "16",
    cy: "11.333",
    r: "10.667"
  }), React.createElement("circle", {
    cx: "16",
    cy: "11.333",
    r: "7.333",
    fill: "#FFF"
  }), React.createElement("path", {
    d: "M16 6.887L17.553 10 20.667 10 18.073 11.92 19.113 15.473 16 13.487 12.887 15.413 13.927 11.927 11.333 10 14.447 10z"
  })));
};